import BaseEvaluator from './BaseEvaluator';

export default class UUIDEvaluator extends BaseEvaluator {
  constructor(fieldName, friendlyFieldName, model, mutator = null) {
    super(fieldName, friendlyFieldName, model, mutator);
    this.evaluatorName = 'uuid';
  }

  validate() {
    if (this.value === null || this.value === '') {
      // Allow blank
      this.isValid = true;
    } else {
      this.isValid = this.isUUID();
    }
    return this.isValid;
  }

  isUUID() {
    if (this.value !== undefined && this.value !== null) {
      return (
        `${this.value}`.match(/^[A-Fa-f\d]{8}-?[A-Fa-f\d]{4}-?[A-Fa-f\d]{4}-?[A-Fa-f\d]{4}-?[A-Fa-f\d]{12}$/i) !== null
      );
    }
    return true;
  }
}
